<template>
  <v-container grey--text text--darken-1>
    <v-row class="my-8">
      <v-col cols="12">
        <div
          class="display-3 text-center"
          :style="{ color: $vuetify.theme.themes.dark.primary }"
        >
          About the atlas
        </div>
      </v-col>
    </v-row>
    <v-row class="my-4">
      <v-col cols="auto" xs="12" sm="2">
        <span class="title">Scope</span>
      </v-col>
      <v-col cols="auto" xs="12" sm="10">
        <div class="body-1">
          This project was realized by M.Sc. Geomatics students in the course
          <a
            target="_blank"
            href="https://karto.ethz.ch/studium/lehrangebot/master/multimedia-cartography.html"
            >Multimedia Cartography</a
          >
          (spring semesters 2020 and 2021) at the
          <a target="_blank" href="https://ikg.ethz.ch/"
            >Institute of Cartography and Geoinformation</a
          >, ETH Zurich. It contributes to the
          <a target="_blank" href="https://sustainabledevelopment.un.org/"
            >UN sustainable development goals</a
          >
          and serves as a prototype for the
          <a target="_blank" href="https://atlas.icaci.org/"
            >ICA Commission on Atlases</a
          >. By introducing multimedia-based storytelling techniques and
          interactivity to maps and diagrams, this atlas experimentally extends
          the
          <a target="_blank" href="http://datatopics.worldbank.org/sdgatlas/"
            >World Bank SDG Atlas</a
          >.
        </div>
      </v-col>
    </v-row>
    <v-row class="my-4">
      <v-col cols="12" sm="2">
        <span class="title">Dis&shy;claimer</span>
      </v-col>
      <v-col cols="12" sm="10">
        <div class="body-1">
          Licenses for images, data sources and software libraries have been
          carefully checked and their sources are given at the end of each story
          map. In case you encounter a potential infringement, please let us
          know so that we can resolve it.
        </div>
      </v-col>
    </v-row>
    <v-row class="my-4">
      <v-col cols="12" sm="2">
        <span class="title">Copy&shy;right</span>
      </v-col>
      <v-col cols="12" sm="10">
        <div class="body-1">
          Feel free to share and adapt any material on this website, with
          respect to the original copyright of the material and with giving
          appropriate attribution of our project (e.g. Story Atlas of
          Sustainable Development Goals, ETH Zurich). This corresponds to a
          <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank"
            >Creative Commons Attribution 4.0 International</a
          >
          license for our
          <a
            href="https://en.wikipedia.org/wiki/Copyright_in_compilation"
            target="_blank"
            >copyright in compilation</a
          >.
        </div>
      </v-col>
    </v-row>
    <v-row> </v-row>
    <v-row v-for="(story, i) in stories.items" :key="story.route">
      <v-col cols="12" sm="2" v-if="i == 0">
        <span class="title">Teams</span>
      </v-col>
      <v-spacer v-else></v-spacer>
      <v-col cols="3" sm="2" v-for="member in story.members" :key="member.name">
        <v-img :src="member.image"></v-img>
        <div class="body-1 text-center">{{ member.name }}</div>
      </v-col>
      <v-col cols="3" sm="4">
        <h2 class="headline" v-html="story.title" />
      </v-col>
    </v-row>
    <v-row class="my-4">
      <v-col cols="12" sm="2">
        <span class="title">Super&shy;visors</span>
      </v-col>
      <v-col cols="12" sm="10">
        <div class="body-1">
          <div>
            <a
              target="_blank"
              href="https://ikg.ethz.ch/personen/people/person-detail.ODM2OTM=.TGlzdC82OTUsLTkwODE0Mjky.html"
              >René Sieber</a
            >
            (Point of contact)
          </div>
          <div>
            <a
              target="_blank"
              href="https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fstatic.onecms.io%2Fwp-content%2Fuploads%2Fsites%2F24%2F2020%2F06%2F17%2Fnote.jpg"
              >Hans-Rudolf Bär</a
            >
          </div>
          <div>
            <a
              target="_blank"
              href="https://ikg.ethz.ch/personen/people/person-detail.MTgzOTI2.TGlzdC82OTUsLTkwODE0Mjky.html"
              >Raimund Schnürer</a
            >
          </div>
          <div>
            <a
              target="_blank"
              href="https://ikg.ethz.ch/personen/people/person-detail.Mjc4MjQw.TGlzdC82OTUsLTkwODE0Mjky.html"
              >Sidi Wu</a
            >
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="my-4 d-flex align-center">
      <v-spacer></v-spacer>
      <v-col cols="6" sm="5" style="padding: 12px;">
        <img
          src="@/assets/ikg_logo.png"
          style="background-color: white; max-width: 200px;"
        />
      </v-col>
      <v-col cols="6" sm="5" style="padding: 12px;" class="d-flex justify-end">
        <img style="max-width: 200px;" src="@/assets/eth_logo.png" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import stories from "@/models/stories";

export default {
  name: "Imprint",
  data: () => ({
    stories
  })
};
</script>
<style>
html {
  overflow-y: auto !important;
}
</style>
<style scoped>
.container {
  max-width: 1200px !important;
}
</style>
